import { HttpUrlEncodingCodec } from '@angular/common/http';

export class NaiveParameterCodec extends HttpUrlEncodingCodec {
  encodeValue(value: string) {
    return encodeURIComponent(value);
  }
}
